import { useEffect, useState } from "react";
import { Button, FloatingLabel, FormControl, FormSelect, Modal, Spinner } from "react-bootstrap";
import { FaArrowRight, FaCircleXmark } from "react-icons/fa6";
import { TbCoins } from "react-icons/tb";
import {MdOutlineSend} from "react-icons/md";
import energoLogo from "../../../color-logo.svg";
import { FaCheckCircle } from "react-icons/fa";
import PrivateApi from "../../../services/PrivateApiService";
import { useAuthState } from "../../../context/AuthContext";
import { useQueryClient } from "react-query";
import EmployeeStage from "../../anlage/new_anlage/EmployeeStage";

const TzbChangeModal = ({elv, energieprodukt, show, setShow}) => {

    const API = new PrivateApi();
    const { user, contactPerson } = useAuthState();
    const queryClient = useQueryClient();

    const [view, setView] = useState("default");
    const [newTzb, setNewTzb] = useState("");
    const [higherChange, setHigherChange] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");
    const [inputReason, setInputReason] = useState("");
    const [apiError, setApiError] = useState("");


    useEffect(() => {
        if (show === true) {
            if (user.x_is_house_management === true && contactPerson === null) setView("hwContact"); 
        }
    }, [show])


    const newTzbHandler = (event) => {
        var newVal = event.target.value;

        // return if not number or comma
        if (!/^\d*([,]\d*)?$/.test(newVal)) return;

        setNewTzb(newVal);

        if (newVal !== "" && Number(newVal) <= (Number(elv.x_teilvorschreibung_brutto) * 0.94)) setHigherChange(true);
        else setHigherChange(false);
    }

    const sendChangeRequest = () => {
        setView("loading");

        if (!/^\d*([,]\d*)?$/.test(newTzb)) return;
        if (Number(newTzb) <= (Number(elv.x_teilvorschreibung_brutto) * 0.94)) {
            if (selectedReason === "") return;
            if (selectedReason === "Sonstiges" && (!inputReason || inputReason.length < 4)) return;
        }
        if (user.x_is_house_management === true && (!contactPerson || contactPerson === null)) return;

        // create data for sending.
        let data = {
            id: elv.id,
            betrag: newTzb,
        }
        if (contactPerson && contactPerson !== null) data['contact'] = contactPerson;
        if (Number(newTzb) <= (Number(elv.x_teilvorschreibung_brutto) * 0.94)) {
            data["selectedReason"] = selectedReason;
            if (selectedReason === "Sonstiges") data["sonstigesReason"] = inputReason
        }

        API.post_ElvsTeilvorschrebungsEdit(data)
            .then(() => {
                queryClient.invalidateQueries("GET_ELV_DETAILS_QUERY");
                setView("done");
            })
            .catch(err => {
                setApiError(err?.response?.data?.detail || "Unbekannter Fehler ist aufgetreten, versuchen Sie später nochmal.");
                setView("error");
            });
    }

    const resetAndCloseModal = () => {
        setView("default");
        setNewTzb("");
        setHigherChange(false);
        setSelectedReason("");
        setShow(false);
    }

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header className="bg-warning d-flex gap-2">
                <TbCoins size={30} />
                <b>Teilvorschreibung anpassen</b>
            </Modal.Header>
            <Modal.Body>
                {
                    view === "default" ? 
                        <>
                            <p>
                                <small className="text-muted">
                                    Hier können Sie uns mitteilen, wenn Sie die Höhe 
                                    Ihres Teilvorschreibungsbetrags anpassen möchten. 
                                    Geben Sie den gewünschten Betrag ein und klicken 
                                    Sie auf “Absenden”. Wir leiten Ihren Wunsch an 
                                    den Energieversorger weiter.
                                </small>
                            </p>
                            <p><small className="text-muted">Aktueller Teilvorschreibungsbetrag: </small>  {Number(elv.x_teilvorschreibung_brutto).toFixed(2)} €</p>
                            <div className="mt-3">
                                <FloatingLabel label="Neuer Teilvorschreibungsbetrag">
                                    <FormControl
                                        value={newTzb}
                                        onChange={e => newTzbHandler(e)}
                                        placeholder="Neuer Teilvorschreibungsbetrag" 
                                    />
                                </FloatingLabel>
                            </div>
                            {higherChange &&
                                <div className="mt-3">
                                    <p>
                                        <small className="text-muted">
                                            Für eine Senkung des Teilzahlungsbetrags um mehr als
                                            fünf Prozent benötigt {energieprodukt.x_energielieferant_id[1]}&nbsp;
                                            eine Begründung. <br/> Bitte wählen Sie aus:
                                        </small>
                                    </p>
                                    <FormSelect 
                                        size="lg"
                                        value={selectedReason}
                                        onChange={e => setSelectedReason(e.target.value)}
                                        isValid={selectedReason !== ""}
                                    >
                                        <option value="">Grund auswählen</option>
                                        <option value="Neue PV-Anlage">Neue PV-Anlage</option>
                                        <option value="Weniger Personen im Haushalt">Weniger Personen im Haushalt</option>
                                        <option value="Wasserschaden und Trocknung">Wasserschaden und Trocknung</option>
                                        <option value="Mitglied in einer Energiegemeinschaft">Mitglied in einer Energiegemeinschaft</option>
                                        <option value="Sonstiges">Sonstiges</option>
                                    </FormSelect>
                                </div>
                            }
                            {selectedReason === "Sonstiges" && higherChange &&
                                <div className="mt-3">
                                    <p>
                                        <small className="text-muted">
                                            Bitte ergänzen Sie den Grund für Ihre Auswahl.
                                        </small>
                                    </p>
                                    <FormControl
                                        as={"textarea"}
                                        value={inputReason}
                                        onChange={e => setInputReason(e.target.value)}
                                        isValid={inputReason && inputReason.length > 4}
                                    />
                                </div>
                            }
                        </>
                    :
                    view === "loading" ?
                        <div className="text-center">
                            <p>Neur Teilvorschreibungsbetrag wird übermittelt.</p>
                            <Spinner animation="border" variant="warning" />
                        </div>
                    :
                    view === "done" ?
                        <div className="text-center">
                            <div className="d-flex gap-4 align-items-center justify-content-center">
                                <TbCoins size={60} className="text-warning" />
                                <FaArrowRight size={30} />
                                <MdOutlineSend size={40} />
                                <FaArrowRight size={30} />
                                <div className="d-flex flex-column align-items-center">
                                    <img src={energoLogo} alt="energo" width={70} />
                                    <FaCheckCircle size={20} className="text-energo" />
                                </div>
                            </div>
                            <div className="mt-3">
                                <p>
                                    Wir haben Ihre Eingabe erhalten und leiten Ihren Wunsch an den Energielieferanten weiter.
                                </p>
                            </div>
                        </div>
                    :
                    view === "error" ?
                        <div className="text-center">
                            <h5 className="text-danger">Fehler passiert!</h5>
                            <div className="d-flex gap-4 align-items-center justify-content-center">
                                <TbCoins size={60} className="text-warning" />
                                <FaArrowRight size={30} />
                                <MdOutlineSend size={40} />
                                <FaArrowRight size={30} />
                                <FaCircleXmark size={50} className="text-danger" />
                            </div>
                            <p>{apiError}</p>
                        </div>
                    :
                    view === "hwContact" ?
                        <>
                            <EmployeeStage setStage={setView} setShow={setShow} />
                        </>
                    :
                        null
                }
            </Modal.Body>
            <Modal.Footer className="text-end" hidden={view === "loading"}>
                {view === "default" &&
                    <div className="d-flex gap-3">
                        <Button onClick={() => resetAndCloseModal()} variant="warning">Abbrechen</Button>
                        <Button onClick={() => sendChangeRequest()} variant="energo">Absenden</Button>
                    </div>
                }
                {view === "done" &&
                    <Button onClick={() => resetAndCloseModal()} variant="energo">Schließen</Button>
                }
                {view === "error" &&
                    <Button variant="warning" onClick={() => setView("default")}>Zurück</Button>
                }

            </Modal.Footer>
        </Modal>
    )
}
export default TzbChangeModal;